/** A bank account's verification state as a badge: the colour follows the state, the word names it. */
import { Badge, type BadgeProps } from '@insio/ui-toolkit';
import { BankAccountVerificationState } from '@insio/shared-types';
import { useEnumTranslation } from '@/hooks/useEnumTranslation';

const STATE_COLOR: Record<BankAccountVerificationState, NonNullable<BadgeProps['color']>> = {
  [BankAccountVerificationState.UNVERIFIED]: 'neutral',
  [BankAccountVerificationState.PENDING]: 'warning',
  [BankAccountVerificationState.VERIFIED]: 'success',
  [BankAccountVerificationState.REJECTED]: 'error',
  [BankAccountVerificationState.REVOKED]: 'error'
};

interface BankAccountStateBadgeProps {
  state: BankAccountVerificationState;
}

export function BankAccountStateBadge({ state }: BankAccountStateBadgeProps) {
  const tState = useEnumTranslation('bankAccountVerificationState');
  return (
    <Badge size='sm' color={STATE_COLOR[state]} data-state={state}>
      {tState(state)}
    </Badge>
  );
}
